import { TX_TYPES, TX_STATUS, TX_OWNERS, CATEGORIES, RECURRENCE, YESNO, BUDGET_PERIODS, BUDGET_STATUS, FUNDING_TYPES, FUNDING_STATUS, asOpts } from "@/data/financeOptions";

export const transactionFields = (budgetOpts = []) => [
  { name: "description", label: "Description", type: "text", required: true, placeholder: "e.g. Design tool subscription" },
  { name: "transaction_type", label: "Type", type: "select", options: asOpts(TX_TYPES), required: true },
  { name: "amount", label: "Amount (£)", type: "text", required: true, placeholder: "0.00" },
  { name: "status", label: "Status", type: "select", options: asOpts(TX_STATUS), required: true },
  { name: "category", label: "Category", type: "select", options: asOpts(CATEGORIES), required: true },
  { name: "payee", label: "Supplier / payee", type: "text" },
  { name: "transaction_date", label: "Transaction date", type: "date" },
  { name: "due_date", label: "Due date", type: "date" },
  { name: "payment_date", label: "Payment date", type: "date" },
  { name: "owner", label: "Owner", type: "select", options: TX_OWNERS },
  { name: "budget_id", label: "Linked budget", type: "select", options: [{ value: "none", label: "None" }, ...budgetOpts] },
  { name: "recurring", label: "Recurring cost", type: "select", options: asOpts(YESNO) },
  { name: "recurrence", label: "Recurrence", type: "select", options: asOpts(RECURRENCE) },
  { name: "related_workstream", label: "Related workstream", type: "text" },
  { name: "related_campaign", label: "Related campaign", type: "text" },
  { name: "related_milestone", label: "Related launch milestone", type: "text" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const budgetFields = () => [
  { name: "name", label: "Budget name", type: "text", required: true, placeholder: "e.g. Launch marketing budget" },
  { name: "period_type", label: "Period type", type: "select", options: asOpts(BUDGET_PERIODS), required: true },
  { name: "category", label: "Category", type: "select", options: asOpts(CATEGORIES), required: true },
  { name: "planned_amount", label: "Planned amount (£)", type: "text", required: true, placeholder: "0.00" },
  { name: "start_date", label: "Start date", type: "date" },
  { name: "end_date", label: "End date", type: "date" },
  { name: "owner", label: "Owner", type: "select", options: TX_OWNERS },
  { name: "status", label: "Status", type: "select", options: asOpts(BUDGET_STATUS) },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const fundingFields = () => [
  { name: "name", label: "Funding source name", type: "text", required: true, placeholder: "e.g. Director loan (Richard)" },
  { name: "funding_type", label: "Funding type", type: "select", options: asOpts(FUNDING_TYPES), required: true },
  { name: "provider", label: "Provider / investor", type: "text" },
  { name: "amount", label: "Amount (£)", type: "text", placeholder: "0.00" },
  { name: "amount_received", label: "Amount received (£)", type: "text", placeholder: "0.00" },
  { name: "amount_outstanding", label: "Amount outstanding (£)", type: "text", placeholder: "0.00" },
  { name: "status", label: "Status", type: "select", options: asOpts(FUNDING_STATUS), required: true },
  { name: "date_agreed", label: "Date agreed", type: "date" },
  { name: "date_received", label: "Date received", type: "date" },
  { name: "repayment_required", label: "Repayment required", type: "select", options: asOpts(YESNO) },
  { name: "interest_rate", label: "Interest rate (%)", type: "text", placeholder: "0" },
  { name: "repayment_start_date", label: "Repayment start", type: "date" },
  { name: "repayment_end_date", label: "Repayment end", type: "date" },
  { name: "monthly_repayment", label: "Monthly repayment (£)", type: "text", placeholder: "0.00" },
  { name: "conditions", label: "Restrictions / conditions", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const forecastFields = () => [
  { name: "name", label: "Forecast name", type: "text", required: true, placeholder: "e.g. Base case" },
  { name: "opening_balance", label: "Opening cash balance (£)", type: "text", placeholder: "0.00" },
  { name: "start_month", label: "Start month", type: "text", placeholder: "YYYY-MM (e.g. 2026-08)" },
  { name: "duration_months", label: "Duration (months)", type: "text", placeholder: "6" },
  { name: "expected_revenue", label: "Expected monthly revenue (£)", type: "text", placeholder: "0" },
  { name: "expected_funding_inflows", label: "Expected monthly funding inflows (£)", type: "text", placeholder: "0" },
  { name: "expected_founder_salaries", label: "Expected founder salaries (£)", type: "text", placeholder: "0" },
  { name: "expected_freelancer_costs", label: "Expected freelancer costs (£)", type: "text", placeholder: "0" },
  { name: "expected_marketing", label: "Expected marketing spend (£)", type: "text", placeholder: "0" },
  { name: "expected_software", label: "Expected software costs (£)", type: "text", placeholder: "0" },
  { name: "expected_operating_costs", label: "Other operating costs (£)", type: "text", placeholder: "0" },
  { name: "expected_other", label: "Expected other costs (£)", type: "text", placeholder: "0" },
  { name: "expected_oneoff_costs", label: "One-off costs (first month) (£)", type: "text", placeholder: "0" },
  { name: "notes", label: "Notes", type: "textarea" },
];
